/*
 * message dealer 
 * @author: Jason Wong
 * @since: 2018-12-07 09:38:44
 */
import Message from './message';

export default class MessageDispatcher{
    constructor(orderName){
        this._orderName = orderName;
        this._handlers = [];
    }

    /**
     * add message handler
     * @param {Function} handler 
     */
    addHandler(handler){
        if(!handler) throw 'handler can not be null';

        for(var h of this._handlers){
            if(h== handler) return;
        }
        this._handlers.push(handler);
    }

    /**
     * remove message handler
     * @param {Function} handler 
     */
    removeHandler(handler){
        var index = this._handlers.indexOf(handler);
        if(index>-1) this._handlers.splice(index,1);
    }

    /**
     * clear all message handlers
     */
    clearHandlers(){
        this._handlers = [];
    }

    /**
     * test whether inputed message can be dealed
     * @param {Message} message 
     */
    canDeal(message){
        return message && message.name == this._orderName;
    }

    /**
     * deal Message
     * @param {Message} message 
     */
    deal(message){
        this._handlers.forEach(handler => {
            try{
                handler(message);
            }catch(err){
                console.error(err);
            }
        });
    }
}